import { DateTime } from 'luxon';
import { Table } from 'react-bootstrap';
import { SpaceWithOwner } from './GroupBookingsList';

/**
 * Travel Information Row
 *
 * Display travel information for a guest/participant
 */
export function TravelInformationRow({ space }: { space: SpaceWithOwner }) {
  const guestName = space.guest.givenName
    ? `${space.guest.givenName} ${space.guest.familyName}`
    : undefined;
  const ownerName = `${space.owner.givenName} ${space.owner.familyName}`;

  // [additionalInformation] may be present while [travelInformation] is not
  // hence the need to show it even when [travelInformation] is empty
  const additionalInformation = space.guest.tripForm?.additionalInformation;

  if (!space.guest.tripForm?.travelInformation) {
    return (
      <tr>
        <td>{guestName || <i>Booked by {ownerName}</i>}</td>
        <td colSpan={additionalInformation ? 6 : 7} className="text-muted">
          <i>Not completed</i>
        </td>
        {/* If additional information is available display it instead of Not completed */}
        {additionalInformation && <td>{additionalInformation}</td>}
      </tr>
    );
  }

  return (
    <tr>
      <td>{guestName}</td>
      <td>
        {DateTime.fromISO(
          space.guest.tripForm.travelInformation.arrivalTime,
        ).toLocaleString(DateTime.DATETIME_SHORT)}
      </td>
      <td>{space.guest.tripForm.travelInformation.arrivalTransportMode}</td>
      <td>{space.guest.tripForm.travelInformation.arrivalFlightNumber}</td>
      <td>
        {DateTime.fromISO(
          space.guest.tripForm.travelInformation.departureTime,
        ).toLocaleString(DateTime.DATETIME_SHORT)}
      </td>
      <td>{space.guest.tripForm.travelInformation.departureTransportMode}</td>
      <td>{space.guest.tripForm.travelInformation.departureFlightNumber}</td>
      <td>{space.guest.tripForm.additionalInformation}</td>
    </tr>
  );
}

/**
 * Travel Information Table
 *
 * Display travel information for all guests/participants
 */
export default function TravelInformationTable({
  spaces,
}: {
  spaces: SpaceWithOwner[];
}) {
  return (
    <Table striped bordered responsive>
      <thead>
        <tr>
          <th rowSpan={2}>Name</th>
          <th colSpan={3}>Arrival</th>
          <th colSpan={3}>Departure</th>
          <th rowSpan={2}>Additional Information</th>
        </tr>
        <tr>
          <th>Time</th>
          <th>Transport</th>
          <th>Flight</th>
          <th>Time</th>
          <th>Transport</th>
          <th>Flight</th>
        </tr>
      </thead>
      <tbody>
        {spaces.map((space) => (
          <TravelInformationRow space={space} key={space.id} />
        ))}
      </tbody>
    </Table>
  );
}
